export default "__VITE_ASSET__zcvTgB7s__"